(function () {
    'use strict';

    angular
        .module('jotApp')
        .filter('beautifyCommand', beautifyCommand);

    function beautifyCommand() {
        return beautifyCommandFilter;

        function beautifyCommandFilter(input) {
            if (!input) {
                return '';
            }
            return input.replace(/_/g, " ");


        }
    }
})();
